import { Kb3dModel } from './decorators/kb3d-decorator';
import { IImportInfo } from './kb3d-models';
import { Token } from './token';

@Kb3dModel({
    token: Token.ImportInfo,
    trackChanges: false,
})
export class ImportInfo implements IImportInfo {}
